



















































































































































import Component from 'vue-class-component'
import { Vue, Prop } from 'vue-property-decorator'
import { ChartData, ChartOptions } from 'chart.js'
import Chart from '@/components/Chart.vue'
import Modal from '@/components/Modal.vue'

@Component({
  components: {
    Chart,
    Modal
  }
})

export default class ProductSuggest extends Vue {
  @Prop()
  shampooDataArray?: any

  @Prop()
  typePoint?: number[]

  public rateLength = 7

  public prizeIcon = [
    'prize-icon_1',
    'prize-icon_2',
    // 'prize-icon_banner',
    'prize-icon_3'
  ]

  public dialog = {
    0: false,
    1: false,
    2: false
  }

  public updateDialog (value: boolean) {
    this.dialog = {
      0: value,
      1: value,
      2: value
    }
  }

  get localValues () {
    if (this.shampooDataArray !== undefined) {
      const dataArray = []
      this.shampooDataArray.forEach((data: any) => {
        dataArray.push(data.point)
      })
      return 0.75
    } else {
      return [5, 5, 5, 5, 5]
    }
  }

  public openWindowAmazon (url: string) {
    this.$ga.event('amazonLinkButton', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public openWindowYahoo (url: string) {
    this.$ga.event('yahooLinkButton', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public openWindowRakuten (url: string) {
    this.$ga.event('rakutenLinkButton', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public openCramelWindow (url: string) {
    this.$ga.event('toCramelAtProductSuggest', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public pushBannerBota () {
    this.$ga.event('banner_BOTA_at_Rank', 'push')
    window.open('https://monicam.jp/', '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public pushBannerMiddle (url: string) {
    this.$ga.event('pushBannerMiddle', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public openModal () {
    this.$ga.event('openProductModal', 'push')
  }

  private chartData: any = (point: any) => {
    const data = {
      labels: ['泡立ち', '頭皮への優しさ', '髪の補修力', '安全性', '　　仕上がり'],
      datasets: [
        {
          label: 'シャンプー解析',
          data: point.map((point: number) => point * 0.75),
          backgroundColor: [
            'rgba(0, 173, 181, 0.5)'
          ],
          borderColor: [
            'rgba(0, 173, 181, 1)'
          ],
          borderWidth: 1
        },
        {
          label: 'アナタのタイプ',
          data: this.typePoint,
          backgroundColor: [
            'rgba(255, 190, 11, 0.5)'
          ],
          borderColor: [
            'rgba(255, 190, 11, 1)'
          ],
          borderWidth: 1
        }
      ]
    }
    return data
  }

  private chartOption: ChartOptions = {
    scale: {
      angleLines: {
        display: false
      },
      ticks: {
        suggestedMin: 0,
        suggestedMax: 6
      }
    },
    legend: {
      display: true,
      position: 'bottom'
    }
  }
}
